import { useEffect } from "react";
import moment from "moment";
import { useForm } from "react-hook-form";
import { usePadresProductoTerminado } from "../../hooks/usePadresProductoTerminado";

// Estado de los filtros que comparten los reportes de producción: el rango de
// fechas y el padre PT. El reporte que lo usa solo pone qué hacer al consultar
// y al exportar; el rango y el padre PT se le entregan ya listos para el backend
export const useFiltrosReporteProduccion = ({
    storageKey,
    onConsultar,
    onDescargar,
}) => {
    const filtrosGuardados =
        JSON.parse(sessionStorage.getItem(storageKey)) || {};

    const {
        control: formControl,
        formState: { errors: formErrors },
        handleSubmit: formHandleSubmit,
        watch: formWatch,
    } = useForm({
        defaultValues: {
            fecha_inicial: filtrosGuardados.fecha_inicial
                ? moment(filtrosGuardados.fecha_inicial)
                : null,
            fecha_final: filtrosGuardados.fecha_final
                ? moment(filtrosGuardados.fecha_final)
                : null,
            padre_producto_terminado:
                filtrosGuardados.padre_producto_terminado || null,
        },
    });

    const fechaInicial = formWatch("fecha_inicial");
    const fechaFinal = formWatch("fecha_final");
    const padreProductoTerminado = formWatch("padre_producto_terminado");

    const loadPadresProductoTerminado = usePadresProductoTerminado();

    // las fechas se mandan tal como las eligió el usuario: el backend es el que
    // sabe cómo interpretarlas contra los turnos y los cierres
    const construirParams = (filtros) => {
        const params = {
            padre_producto_terminado_id: filtros.padre_producto_terminado.id,
        };

        if (filtros.fecha_inicial) {
            params.fecha_inicial = moment(filtros.fecha_inicial).format(
                "YYYY-MM-DD",
            );
        }

        if (filtros.fecha_final) {
            params.fecha_final = moment(filtros.fecha_final).format(
                "YYYY-MM-DD",
            );
        }

        return params;
    };

    // se guardan los filtros para volver a la pestaña con lo último consultado
    useEffect(() => {
        sessionStorage.setItem(
            storageKey,
            JSON.stringify({
                fecha_inicial: fechaInicial,
                fecha_final: fechaFinal,
                padre_producto_terminado: padreProductoTerminado,
            }),
        );
    }, [fechaInicial, fechaFinal, padreProductoTerminado]);

    // al entrar se consulta de una vez si los filtros ya venían guardados
    useEffect(() => {
        if (fechaInicial && fechaFinal && padreProductoTerminado) {
            onConsultar(
                construirParams({
                    fecha_inicial: fechaInicial,
                    fecha_final: fechaFinal,
                    padre_producto_terminado: padreProductoTerminado,
                }),
            );
        }
    }, []);

    return {
        formControl,
        formErrors,
        loadPadresProductoTerminado,

        consultarReporte: formHandleSubmit((filtros) =>
            onConsultar(construirParams(filtros)),
        ),
        // el Excel sale con los mismos filtros que la tabla, así que se valida
        // el formulario igual que al consultar
        descargarExcel: formHandleSubmit((filtros) =>
            onDescargar(construirParams(filtros)),
        ),
    };
};
